var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{staticClass:"mt-6 ml-6 mr-4",attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }